import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Upload",
  "use": "Upload-usage",
  "viewBox": "0 0 10 12",
  "content": "<symbol viewBox=\"0 0 10 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Upload\">\n<path d=\"M3.00016 8.66667H7.00016V4.66667H9.66683L5.00016 0L0.333496 4.66667H3.00016V8.66667ZM0.333496 10H9.66683V11.3333H0.333496V10Z\" fill=\"#002B48\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol